import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Slider from '@mui/material/Slider';
import styled from 'styled-components';


import Title from '../Components/Title'

import { 
    WhiteSpace,
    TextL,
    Button,
    TextLinear,
    TextXL,
    TextMax,
    TextM,
    TextS,
    Hr,
    Input,
    BorderLinearProgress,
    HiddenTransform
} from '../../components';

import {
    Card
} from '../../components'

import PurchaseInput,{InvitInput} from '../Components/PurchaseInput'

import {
    // ShortAddress,
    EtherToInt
} from '../../ethers/e'

import { memo, useEffect, useState } from 'react';

import {
    useSilver
} from '../../context/silver'

import {
    useSilverInvest,
    useUnlockSilver
} from '../../hook/silver/uesSilver'


import CountdownMemo from '../Components/Countdown'
import { useTranslation } from 'react-i18next';

import {
    CheckProtocal
} from '../Protocol'


function Harvest() {
    const button = useUnlockSilver()
    return <Button style={{height: "min-content"}} {...button}/>
}

function Index() {
    const {t} = useTranslation()
    const {
        progressing,
        usdgBalance,
        userSilverPools,
        totalLockedUSDG,
        unlockableOfUser,
        totalLocked,
        totalInvestReward,
        teamShare,
        sponsor,
        poolLength
    } = useSilver()
    // console.log(
    //     userSilverPools
    // )
    return (
        <Container>
            <WhiteSpace size={.4}/>
            <Title src='/icon/ag.png' shadow='#4ec3ff'>
                <TextXL style={{lineHeight: '22px'}} >SILVER<TextM style={{marginLeft: '10px'}} color='2'>{t('Asset Portfolio')}</TextM></TextXL>
            </Title>
            <Card style={{overflow:'unset'}} spacing={[0.8, 1]}>
                <WhiteSpace size={.4}/>
                <div style={{textAlign:'center'}}>
                    <TextM color='2'>{t('Cumulative Sales')} USDG</TextM>
                    <WhiteSpace size='0'/>
                    <TextLinear linear={1} style={{fontSize: '1.8rem'}}>{EtherToInt(totalLockedUSDG)}</TextLinear>
                    {/* <TextMax>123321,1231223 </TextMax> */}
                    
                </div>  
                <WhiteSpace size={.6}/>
                <Stack 
                    direction="row"
                    justifyContent="space-between"
                    divider={<Divider sx={{ borderColor: 'rgb(81 199 254)' }} orientation="vertical" flexItem />}
                    style={{
                        background: 'linear-gradient(45deg, rgb(37 39 46), rgb(48 49 56))',
                        padding: '10px 0px',
                        borderRadius: '14px'
                    }}
                    // spacing={1}
                >
                    <div style={{textAlign:'center', width:'100%'}}>
                        <TextS color='2'>{t('Settlement')}</TextS>
                        <br />
                        <TextL>7D</TextL>
                    </div>
                    <div style={{textAlign:'center', width:'100%'}}>
                        <TextS color='2'>{t('Fundraising')}</TextS>
                        <br />
                        <TextL>48H</TextL>
                    </div>
                    <div style={{textAlign:'center', width:'100%'}}>
                        <TextS color='2'>{t('Yield')}</TextS>
                        <br />
                        <TextL>1.2%</TextL>
                    </div>
                </Stack>
            </Card>
            <WhiteSpace />
            {
                progressing.map((v,i) => (
                    <div key={i}>
                        <CardProgress
                            type={v.pId % 2}
                            cardBack='rgb(34 55 66)'
                            buttonType='d'
                            backgroundOfWrap={['#006d95', '#07506a']}
                            config={v}
                            usdgBalance={usdgBalance}
                            sponsor={sponsor}
                            poolLength={poolLength}
                        />
                        <WhiteSpace />
                    </div>
                ))
            }
            <Card style={{overflow:'unset'}} spacing={[0.8, 1]}>
                <Stack 
                    direction="row"
                    justifyContent="space-between"
                    alignItems='center'
                >
                    <div>
                        <TextS color='2'>{t('My Released')} USDG</TextS>
                        <br />
                        <TextXL>{EtherToInt(unlockableOfUser)}</TextXL>
                        {/* <br />
                        <TextS color='2'>Harvest Fee Rate 0.05%</TextS> */}
                    </div>
                    <Harvest />
                </Stack>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <Stack 
                    direction="row"
                    justifyContent="space-between"
                    alignItems='center'
                >
                    <TextM color='2'>{t('Total Locked')} USDG</TextM>
                    <TextM>{EtherToInt(totalLocked)}</TextM>
                    {/* <TextM color='2'>Total Reward USDG</TextM> */}
                    {/* <TextM>{EtherToInt(totalInvestReward)}</TextM> */}
                </Stack>
                <Stack 
                    direction="row"
                    justifyContent="space-between"
                    alignItems='center'
                >
                    <TextM color='2'>{t('Total Reward')} USDG</TextM>
                    <TextM>{EtherToInt(totalInvestReward)}</TextM>
                    {/* <TextM color='2'>Total Reward USDG</TextM> */}
                    {/* <TextM>{EtherToInt(totalInvestReward)}</TextM> */}
                </Stack>
                <Stack 
                    direction="row"
                    justifyContent="space-between"
                    alignItems='center'
                >
                    <TextM color='2'>{t('Team Contribution')} USDG</TextM>
                    <TextM>{EtherToInt(teamShare)}</TextM>
                </Stack>
                <WhiteSpace />
                <Hr />
                <WhiteSpace />
                <MyPosition userSilverPools={userSilverPools}/>
            </Card>
        </Container>
    )
}

export default Index

const cardType = [
    {
        cardBack: 'rgb(34 55 66)',
        buttonType: 'd',
        backgroundOfWrap: ['#065a79', '#2a96c9']
    },
    {
        cardBack: 'rgb(49 58 5)',
        buttonType: 'a',
        backgroundOfWrap: ['#687b08', '#a0bc0f']
    },
]

function CardProgress({type = 0, config, usdgBalance, sponsor, poolLength}) {
    const {buttonType, backgroundOfWrap} = cardType[type]
    const end = (config.startTime + config.recruitmentTime) * 1000
    const reaminRate = (100*(1 - config.remainFunds / config.hardCap))
    // funding=0 | expire=1 | relaving=2 | ended=3
    const status = config.status
    const {t} = useTranslation()
    
    return (
        <Card
            style={{
                padding:'12px',
                overflow: 'unset',
                position:'relative',
                width: '100%',
                // background: cardBack
            }}
        >
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems='center'
                sx={{
                    position:'relative',
                    zIndex: '1'
                }}
            >
                
                <Stack style={{
                    display:'flex',
                    flex: '5 1 0%',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginBottom: '4px'
                }}>
                    <Stack>
                        <TextXL
                            style={{
                                display: 'flex',
                                alignItems: 'center'
                            }}
                        >
                            <TextM
                                style={{
                                    display: 'inline-block',
                                    /* height: 40px; */
                                    /* line-height: 47px; */
                                    background: '#f8d83a',
                                    textAlign: 'center',
                                    padding: '0px 8px',
                                    borderRadius: '8px',
                                    marginRight: '4px',
                                    color: 'rgb(36 38 47)'
                                }}
                            >{config.pId + 1}</TextM>
                            {EtherToInt(config.remainFunds)}
                        </TextXL>
                        <TextS color='2'>{t('HardCap')} {EtherToInt(config.hardCap)} USDG</TextS>
                    </Stack>
                </Stack>
                <Stack style={{flex:3, textAlign:'right'}}>
                    <TextXL>{reaminRate.toFixed(3) * 1}%</TextXL>
                    {
                        status === 0 ? 
                        <CountdownMemo end={end}/>:
                        <TextS style={{color: 'rgb(252 88 52)'}}>{t('Ended')}</TextS>
                    }
                    
                </Stack>
            </Stack>
            <CheckProtocal>
                <PurchaseBlock
                    status={status}
                    remainFunds={config.remainFunds}
                    usdgBalance={usdgBalance}
                    pId={config.pId}
                    sponsor={sponsor}
                    button={
                        status !== 0 ? 
                        <Button
                            type='b'
                            style={{
                                width: '100%'
                            }}
                        >{t('Open New Asset Package')} {poolLength+1}</Button> :
                        <Button
                            type='e'
                            // size='large'
                            style={{
                                height: "min-content",
                                // position: 'absolute',
                                width: '100%',
                                // right: '2%',
                                // bottom: '-12px',
                                zIndex: '1',
                                padding: '0',
                                background: backgroundOfWrap[0],
                                borderRadius: '18px',
                                overflow: 'hidden'
                            }}
                        >   
                            <CardProgressWrap rate={reaminRate} background={backgroundOfWrap} type={buttonType}>
                                <div style={{
                                    position: 'absolute',
                                    width:'100%',
                                    borderRadius: '18px'
                                }}>{t('Purchase')}</div>
                            </CardProgressWrap>
                        </Button>
                    }
                />
            </CheckProtocal>
        </Card>
    )
}

// const default_seconds = '0.4s'
const CardProgressWrap = styled('div')`
    background: ${p => p.background[1]};
    /* position: relative; */
    width: ${p => p.rate || 0}%;
    margin-left: -${p => (100 - p.rate) || 0}%;
    z-index: 0;
    height: 34px;
    border-radius: 50px;
    padding: 6px 0;

    /* animation: backgroundOfWrap${p => p.type} 2s ease-in-out infinite;
    
    @keyframes backgroundOfWrap${p => p.type} {
        0% {
            background-color: ${p => p.background[0]};
        }
        50% {
            background-color: ${p => p.background[1]};
        }
        100% {
            background-color: ${p => p.background[0]};
        }
    } */
    /* @keyframes breathe {
        0% {
            background-color: linear-gradient(45deg, rgba(5, 57, 72, 0.3), rgba(4, 106, 103, .3));
        }
        50% {
            background-color: linear-gradient(45deg, rgba(5, 57, 72, 0.7), rgba(4, 106, 103, .7));
        }
        100% {
            background-color: linear-gradient(45deg, rgba(5, 57, 72, 1), rgba(4, 106, 103, 1));
        }
    } */

`

function PurchaseBlock({button, remainFunds=0, usdgBalance, pId, sponsor, status}) {
    const [open,setOpen] = useState(false)
    const {
        inputAmount,
        inviter,
        button: pButton
    } = useSilverInvest(pId, status)
    const needInviter = sponsor === ''
    useEffect(() => {
        if (!needInviter) inviter.onChange(sponsor)
    },[sponsor, needInviter])

    useEffect(() => {
        if (inviter.value*1 === -1) {
            setOpen(false)
        }
    }, [inviter.value])
    const {t} = useTranslation()

    return (
        <>  
            <HiddenTransform open={!open} onClick={()=> setOpen(!open)}>
                {button}
            </HiddenTransform>
            <HiddenTransform open={open}>
                <WhiteSpace size={1}/>
                <Hr />
                <WhiteSpace size={.8}/>
                <PurchaseInput
                    slider
                    input={inputAmount}
                    balance = {{
                        token: 'USDG',
                        amount: usdgBalance,
                        max: remainFunds
                    }}
                />
                {/* <WhiteSpace size={.8}/> */}
                {
                    needInviter && 
                    <InvitInput
                        input={inviter}
                    />
                }
                <TextS style={{margin:'16px 0px', display: 'block'}} color='2'>{t('Maxmum Input')} {EtherToInt(remainFunds)} USDG</TextS>
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems='center'
                >
                    <Button type='f' style={{width:'25%'}} onClick={()=> setOpen(!open)}>{t('Cancel')}</Button>
                    <Button
                        style={{width:'72%'}}
                        disabled={inputAmount.value*1 > usdgBalance*1}
                        {...pButton}
                    />
                </Stack>
                <WhiteSpace />
            </HiddenTransform> 
        </>
    )
}

// const BackLine = styled('div')`
//     position: relative;
//     width: 100%;
//     ::before {
//         content: '';
//         position: absolute;
//         left: 0;
//         top: 50%;
//         width: 100%;
//         background-color: #ddd;
//         height: 1px;
//         z-index: -1;
//     }
// `

// success 0
function MyPosition({userSilverPools}) {
    const {t} = useTranslation()
    const [table, setTable] = useState(2)
    return (
        <>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems='center'
            >
                <TextM>{t('My Position')}</TextM>
                <div>
                    <TextS
                        style={{padding: '3px 6px'}}
                        onClick={() => {
                            setTable(2)
                        }}
                        color={table===2?'1':'2'}
                    >{t('Releasing')}</TextS>
                    <TextM color='2'>|</TextM>
                    <TextS
                        style={{padding: '3px 6px'}}
                        onClick={() => {
                            setTable(1)
                        }}
                        color={table===1?'1':'2'}
                    >{t('Ended')}</TextS>
                    <TextM color='2'>|</TextM>
                    <TextS
                        style={{padding: '3px 6px'}}
                        onClick={() => {
                            setTable(0)
                        }}
                        color={table===0?'1':'2'}
                    >{t('Fail')}</TextS>
                </div>
            </Stack>
            <WhiteSpace />
            {
                userSilverPools.length === 0 ?
                null:
                userSilverPools.filter(v => {
                    // funding=0 | expire=1 | relaving=2 | ended=3
                    let filter;
                    if (table === 1) {
                        filter = v.status === 3
                    } else if (table === 0) {
                        filter = v.status === 1
                    } else {
                        filter = v.status === 0 ||  v.status === 2
                    }
                    return filter
                }).sort((a,b) => b.pId - a.pId).map(v => (
                    <div key={v.pId}>
                        <Hr />
                        <WhiteSpace />
                        <Stack>
                            <Stack 
                                direction="row"
                                justifyContent="space-between"
                                alignItems='center'
                            >
                                <TextS color='2'>
                                    <TextS
                                        style={{
                                            display: 'inline-block',
                                            /* height: 40px; */
                                            /* line-height: 47px; */
                                            background: '#f8d83a',
                                            textAlign: 'center',
                                            padding: '0px 8px',
                                            borderRadius: '8px',
                                            marginRight: '4px',
                                            color: 'rgb(36 38 47)'
                                        }}
                                    >{v.pId + 1}</TextS>
                                    {t('Reward')}</TextS>
                                <TextS>{EtherToInt(v.reward)}</TextS>
                            </Stack>
                            <Stack 
                                direction="row"
                                justifyContent="space-between"
                                alignItems='center'
                            >
                                <TextS color='2'>{t('Team Reward')}</TextS>
                                <TextS>{EtherToInt(v.shareReward)}</TextS>
                            </Stack>
                            <Stack 
                                direction="row"
                                justifyContent="space-between"
                                alignItems='center'
                            >
                                <TextS color='2'>{t('Funds')}</TextS>
                                <TextS>{EtherToInt(v.funds)}</TextS>
                            </Stack>
                            <Stack 
                                direction="row"
                                justifyContent="space-between"
                                alignItems='center'
                            >
                                <TextS color='2'>{t('Unlock Time')}</TextS>
                                {
                                    v.status === 1 ?
                                    <TextS style={{color: 'rgb(252 88 52)'}}>{t('Fail')}</TextS> :
                                    v.status === 0 ?
                                    <TextS style={{color: '#dcfc34'}}>{t('Fundraising')}</TextS> :
                                    v.status === 3 ?
                                    <TextS >{t('Ended')}</TextS> :
                                    <CountdownMemo end={v.endTime * 1000} /> 
                                }
                            </Stack>
                            <Stack 
                                direction="row"
                                justifyContent="space-between"
                                alignItems='center'
                            >
                                <TextS color='2'>{t('Ended Time')}</TextS>
                                <TextS>{v.endDate}</TextS>
                            </Stack>
                            <Stack 
                                direction="row"
                                justifyContent="space-between"
                                alignItems='center'
                            >
                                <TextS color='2'>CV</TextS>
                                <TextS>{v.funds}</TextS>
                            </Stack>
                        </Stack>
                        <WhiteSpace />
                    </div>
                ))
            }
        </>
    )
}